import { useQuery } from '@tanstack/react-query';

import { IRiskAnalysisGoodsRef } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

interface HookProps {
  batchId: string;
}

export const retrieveDeclarationsRefsByImpact = async ({ batchId }: HookProps): Promise<IRiskAnalysisGoodsRef[]> => {
  try {
    const { data } = await request({
      path: `declarations/${batchId}/retrieve-declarations-refs-by-impact`,
      method: 'GET',
      authenticate: true,
    });
    return data;
  } catch (error) {
    showErrorToast(error, 'Failed to fetch declarations refs');
  }
};

export const useDeclarationsRefsByImpact = ({ batchId }: HookProps) =>
  useQuery({
    queryKey: ['declaration-type', batchId],
    queryFn: async () => retrieveDeclarationsRefsByImpact({ batchId }),
    placeholderData: [],
  });
